import { useTheme } from "@mui/material"
import { useContextState } from "../../../../../../../../hooks/theme"

export const useStyles = () => {
    const { colors } = useContextState()
    const { breakpoints } = useTheme()
    return {
        topContainer: {
            backgroundColor: "#fafafa",
            p: 2,
        },
        mainContainer: (hasItems: boolean, column: boolean) => ({
            marginBottom: column ? 0 : 2,
            padding: 1,
            color: colors.color9,
            display: 'flex',
            gap: 2,
            bgcolor: 'white',
            alignItems: hasItems ? 'flex-start' : 'center',
            width: column ? '48%' : '100%',
            flex: column ? '1 1 48%' : '1 1 100%',
        }),
        superior: {
            width: '100%',
        },
        iconSetting: {
            '& .MuiSvgIcon-root': {
                fontSize: '2rem'
            },
            paddingTop: '4px',
        },
        dropList: {
            display: 'flex',
            '& .MuiTypography-root': {
                wordBreak: "break-word",
                overflowWrap: "break-word",
                whiteSpace: "normal",
            },
        },
        categoriesContainer: (column: boolean) => ({
            maxHeight: '250px',
            overflow: 'auto',
            display: column ? 'flex' : 'block',
            gap: column ? 3 : 0,
            width: '100%',
            flexWrap: column ? 'wrap' : 'nowrap',
            justifyContent: column ? 'space-between' : 'flex-start',
        })
    }
}